module.exports = __webpack_public_path__ + "img/foot-left-top.c4851053.png";